<template>
  <div class="container-fluid px-4" style="max-width: 1300px">
    <label v-if="showSearch" class="menu-search">
      <b-icon icon="search" aria-hidden="true" />
      <span class="sr-only">Buscar en la carta</span>
      <input v-model.trim="searchQuery" type="search" placeholder="Buscar en la carta" autocomplete="off" />
    </label>
    <div class="row h-100" v-if="loading">
      <div class="col-12 h-100 text-center" style>
        <div class="w-100 py-5"></div>
        <b-spinner type="grow" label="Spinning"></b-spinner>
        <div class="w-100"></div>
        <span>Cargando...</span>
      </div>
    </div>

    <div class="row">
      <nav
        class="navbar sticky-top border-bottom nav-categories py-0 w-100"
        :class="[
          `nav-categories--${categoryMenuStyle}`,
          {
            'nav-categories--overflow': hasCategoryOverflow,
            'nav-categories--can-scroll-left': showLeftCategoryNav,
            'nav-categories--can-scroll-right': showRightCategoryNav,
          },
        ]"
        :style="navThemeVars"
        id="nav-categories"
        ref="nav-categories"
        aria-label="Categorías del menú"
      >
        <button
          v-if="showLeftCategoryNav"
          type="button"
          class="category-nav category-nav--left"
          aria-label="Ver categorías anteriores"
          @click="scrollCategories('left')"
        >
          <b-icon icon="chevron-left"></b-icon>
        </button>
        <div
          class="slider position-relative1 w-100 category-nav__scroller"
          ref="scroll-cat"
          id="scroll-categories"
          role="list"
        >
          <div
            class="px-3 item category-nav__item"
            v-for="cat in categories"
            :key="cat._id"
            :ref="`cat-${cat._id}`"
            style="border-bottom-width: 2px !important"
            :class="{ 'category-nav__item--active': cid == cat._id }"
            role="listitem"
          >
            <a
              :class="{ active: cid == cat._id }"
              :aria-pressed="cid == cat._id ? 'true' : 'false'"
              @click="setCategory(cat, $event)"
              @keydown.enter.prevent="setCategory(cat, $event)"
              @keydown.space.prevent="setCategory(cat, $event)"
              class="item text-nowrap text-uppercase click category-nav__link"
              role="button"
              tabindex="0"
              ><b-icon
                v-if="showCategoryNavIcons"
                :icon="categoryMenuIcon(cat)"
                class="category-nav__icon"
                aria-hidden="true"
              ></b-icon>{{ cat.name }}</a
            >
          </div>
        </div>
        <button
          v-if="showRightCategoryNav"
          type="button"
          class="category-nav category-nav--right"
          aria-label="Ver más categorías"
          @click="scrollCategories('right')"
        >
          <b-icon icon="chevron-right"></b-icon>
        </button>
      </nav>
      <div class="w-100">
        <section
          class="section"
          v-if="!searchQuery && settings.showRecomended && recomendedList.length > 0"
        >
          <div class="w-100 d-block pb-5"></div>
          <h3
            class="mt-3 text-uppercase border-bottom font-weight-bolder text-center pb-3"
          >
            RECOMENDADOS
            <div
              class="badge animate__animated animate__tada animate__infinite infinite"
            >
              <b-icon icon="star-fill" class="text-warning"></b-icon>
            </div>
          </h3>
          <div class="row home-product-grid">
            <div
              class="col-md-6 col-lg-6 col-xl-4 col-12 click py-1 home-product-grid__item"
              @click="viewProduct(p._id, p.name)"
              @keydown.enter="viewProduct(p._id, p.name)"
              @keydown.space.prevent="viewProduct(p._id, p.name)"
              role="button"
              tabindex="0"
              :aria-label="`Ver ${p.name}`"
              v-for="p in recomendedList"
              :key="p._id"
            >
              <div
                class="card justify-content-center card-product product-single home-product-card"
                :class="`home-product-card--${singleProductLayout}`"
                style="overflow-x: hidden"
              >
                <div class="row no-gutters">
                  <div class="col-md-4 p-0 col-5 text-center overflow-hidden position-relative home-product-card__media">
                    <img
                      :src="getImage(p.image, 'small')"
                      :alt="p.name"
                      class="home-product-card__image"
                      width="320"
                      height="200"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div class="col-md-8 col p-2 home-product-card__details">
                    <div class="card-body px-2 py-1">
                      <span
                        class="card-title text-uppercase font-weight-bold product-single__title"
                        >{{ p.name }}</span
                      >
                      <small
                        class="d-block text-secondary"
                        v-if="getCardPrice(p) < p.value"
                        style="font-size: 11px; line-height: 1"
                      >
                        <s>${{ formatNumber(p.value) }}</s>
                      </small>
                      <div class="badge badge-danger badge-pill">
                        <span style="font-size: 12px">
                          ${{ formatNumber(getCardPrice(p)) }}
                        </span>
                      </div>
                      <div
                        v-if="getExclusiveAvailability(p)"
                        class="home-availability-badge mt-2 mb-1"
                      >
                        <span class="home-availability-value">
                          {{ getExclusiveAvailability(p) }}
                        </span>
                      </div>
                      <div class="w-100 py-1"></div>
                      <small
                        class="d-block pr-2 mt"
                        v-if="p.description"
                        style="white-space: normal; font-weight: 500"
                      >
                        {{ p.description.slice(0, 60) }}
                        <span v-if="p.description.length > 60">...</span>
                      </small>
                      <small class="text-muted" v-else>Sin descripcion</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          class="section"
          v-if="
            !searchQuery && settings.showMostSoldProducts && listProductsMostSelled.length > 0
          "
        >
          <div class="w-100 d-block pb-5"></div>
          <h1
            class="mt-3 text-uppercase border-bottom font-weight-bolder text-center pb-3 fs-3"
          >
            MAS VENDIDOS
            <div
              class="badge badge-danger animate__animated animate__tada animate__infinite infinite"
            >
              <small>HOT</small>
            </div>
          </h1>
          <div class="row home-product-grid">
            <div
              class="col-md-6 col-lg-6 col-xl-4 col-12 click py-1 home-product-grid__item"
              @click="viewProduct(p._id, p.name)"
              @keydown.enter="viewProduct(p._id, p.name)"
              @keydown.space.prevent="viewProduct(p._id, p.name)"
              role="button"
              tabindex="0"
              :aria-label="`Ver ${p.name}`"
              v-for="p in listProductsMostSelled"
              :key="p._id"
            >
              <div
                class="card justify-content-center card-product product-single home-product-card"
                :class="`home-product-card--${singleProductLayout}`"
                style="overflow-x: hidden"
              >
                <div class="row no-gutters">
                  <div class="col-md-4 p-0 col-5 text-center overflow-hidden position-relative home-product-card__media">
                    <img
                      :src="getImage(p.image, 'small')"
                      :alt="p.name"
                      class="home-product-card__image"
                      width="320"
                      height="200"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div class="col-md-8 col p-2 home-product-card__details">
                    <div class="card-body px-2 py-1">
                      <span
                        class="card-title text-uppercase font-weight-bold product-single__title"
                        >{{ p.name }}</span
                      >
                      <small
                        class="d-block text-secondary"
                        v-if="getCardPrice(p) < p.value"
                        style="font-size: 11px; line-height: 1"
                      >
                        <s>${{ formatNumber(p.value) }}</s>
                      </small>
                      <div class="badge badge-danger badge-pill">
                        <span style="font-size: 12px">
                          ${{ formatNumber(getCardPrice(p)) }}
                        </span>
                      </div>
                      <div
                        v-if="getExclusiveAvailability(p)"
                        class="home-availability-badge mt-2 mb-1"
                      >
                        <span class="home-availability-value">
                          {{ getExclusiveAvailability(p) }}
                        </span>
                      </div>
                      <div class="w-100 py-1"></div>
                      <small
                        class="d-block pr-2 mt"
                        v-if="p.description"
                        style="white-space: normal; font-weight: 500"
                      >
                        {{ p.description.slice(0, 60) }}
                        <span v-if="p.description.length > 60">...</span>
                      </small>
                      <small class="text-muted" v-else>Sin descripcion</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          class="section w-100 home-category-section"
          v-for="cat in visibleCategories"
          :key="cat._id"
          :ref="`fat-${cat._id}`"
          :data-id="cat._id"
        >
          <div
            class="border-bottom pb-3 home-category-header"
            :class="`home-category-header--${normalizedCategoryNameAlign}`"
          >
            <div class="home-category-header__inner">
              <b-icon
                v-if="showCategoryHeadingIcons"
                :icon="categoryMenuIcon(cat)"
                class="home-category-heading__icon"
                :style="{ color: categoryMenuAccent }"
                aria-hidden="true"
              ></b-icon>
              <div class="home-category-header__copy">
                <h1 class="text-uppercase font-weight-bolder fs-3 home-category-heading">
                  {{ cat.name }}
                </h1>
                <p
                  v-if="showCategoryDescription && cat.description && cat.description.trim()"
                  class="home-category-description"
                >
                  {{ cat.description }}
                </p>
              </div>
            </div>
          </div>
          <div class="row home-product-grid">
            <div
              class="col-md-6 col-lg-6 col-xl-4 col-12 click py-1 home-product-grid__item"
              @click="viewProduct(p._id, p.name)"
              @keydown.enter="viewProduct(p._id, p.name)"
              @keydown.space.prevent="viewProduct(p._id, p.name)"
              role="button"
              tabindex="0"
              :aria-label="`Ver ${p.name}`"
              v-for="p in listProducts(cat)"
              :key="p._id"
            >
              <div
                class="card justify-content-center card-product product-single home-product-card"
                :class="`home-product-card--${singleProductLayout}`"
                style="overflow-x: hidden"
              >
                <div class="row no-gutters">
                  <div
                    class="col-md-4 p-0 col-5 text-center overflow-hidden position-relative home-product-card__media"
                    v-if="showProductImage(p.image)"
                  >
                    <img
                      :src="getImage(p.image, 'small')"
                      :alt="p.name"
                      class="home-product-card__image"
                      width="320"
                      height="200"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div class="col-md col p-2 home-product-card__details">
                    <div class="card-body px-2 py-1">
                      <span
                        class="card-title text-uppercase font-weight-bold product-single__title"
                        >{{ p.name }}</span
                      >
                      <div
                        v-if="getPromos(p)"
                        class="badge badge-warning animate__animated animate__tada animate__infinite infinite position-absolute"
                        style="top: 5px; right: 5px; z-index: 1"
                      >
                        <span>{{ getPromos(p) }}</span>
                      </div>
                      <div class="w-100"></div>
                      <small
                        class="d-block text-secondary"
                        v-if="getCardPrice(p) < p.value"
                        style="font-size: 11px; line-height: 1"
                      >
                        <s>${{ formatNumber(p.value) }}</s>
                      </small>
                      <div class="badge badge-danger badge-pill">
                        <span style="font-size: 12px">
                          ${{ formatNumber(getCardPrice(p)) }}
                        </span>
                      </div>
                      <div
                        v-if="getExclusiveAvailability(p)"
                        class="home-availability-badge mt-2 mb-1"
                      >
                        <span class="home-availability-value">
                          {{ getExclusiveAvailability(p) }}
                        </span>
                      </div>
                      <div class="w-100 py-1"></div>
                      <small
                        class="d-block pr-2 mt"
                        v-if="p.description"
                        style="white-space: normal; font-weight: 500"
                      >
                        {{ p.description.slice(0, 60) }}
                        <span v-if="p.description.length > 60">...</span>
                      </small>
                      <small class="text-muted" v-else>Sin descripcion</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div v-if="searchQuery && !visibleCategories.length && !loading" class="menu-search-empty">
          <b-icon icon="search" aria-hidden="true" />
          <strong>No encontramos productos</strong>
          <p>Prueba con otro nombre o descripción.</p>
          <button type="button" @click="searchQuery = ''">Limpiar búsqueda</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    showSearch: { type: Boolean, default: false },
    categoryNameAlign: {
      type: String,
      default: "center",
    },
    categoryIconMode: {
      type: String,
      default: "auto",
    },
    showCategoryDescription: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      products: [],
      searchQuery: "",
      category: {},
      pid: null,
      loading: true,
      cid: "",
      listProductsMostSelled: [],
      productName: "Cargando...",
      page: {},
      recomendedList: [],
      navThemeVars: {},
      hasCategoryOverflow: false,
      showLeftCategoryNav: false,
      showRightCategoryNav: false,
      categoryScrollContainer: null,
    };
  },
  computed: {
    visibleCategories() {
      if (!this.showSearch || !this.searchQuery) return this.categories;
      return this.categories.filter((category) => this.listProducts(category).length > 0);
    },
    normalizedCategoryNameAlign() {
      return ["left", "center", "right"].includes(this.categoryNameAlign)
        ? this.categoryNameAlign
        : "center";
    },
    normalizedCategoryIconMode() {
      return ["auto", "show", "hide"].includes(this.categoryIconMode)
        ? this.categoryIconMode
        : "auto";
    },
    showCategoryNavIcons() {
      return this.normalizedCategoryIconMode === "show" ||
        (this.normalizedCategoryIconMode === "auto" && this.categoryMenuStyle === "chips");
    },
    showCategoryHeadingIcons() {
      return this.normalizedCategoryIconMode === "show";
    },
    categoryMenuAccent() {
      return this.normalizeCategoryColor(this.settings && this.settings.categoryMenuAccentColor) || "#e6222e";
    },
    categoryMenuAccentText() {
      return this.normalizeCategoryColor(this.settings && this.settings.categoryMenuAccentTextColor);
    },
    categoryMenuStyle() {
      const style = this.settings && this.settings.categoryMenuStyle;
      return ["classic", "chips", "underline"].includes(style)
        ? style
        : "classic";
    },
    singleProductLayout() {
      const settings = this.settings || {};
      const configuredLayout = settings.productCardLayoutConfigured === true
        ? settings.productCardLayout
        : null;
      if (configuredLayout === "vertical" || configuredLayout === "horizontal") {
        return configuredLayout;
      }

      const legacyLayout = settings.singleProductLayout;
      if (legacyLayout === "vertical" || legacyLayout === "horizontal") {
        return legacyLayout;
      }

      return "horizontal";
    },
    lastscroll() {
      return this.$store.state.lastscroll;
    },
    total() {
      return this.$store.state.products.reduce((t, a) => t + a.total, 0);
    },
    categories() {
      return this.$store.state.categories;
    },
    info() {
      return this.$store.state.info;
    },
    settings() {
      return this.info.settings;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scroll);
    window.removeEventListener("resize", this.updateCategoryNavState);
    if (this.categoryScrollContainer) {
      this.categoryScrollContainer.removeEventListener(
        "wheel",
        this.handleCategoryWheel
      );
      this.categoryScrollContainer.removeEventListener(
        "scroll",
        this.updateCategoryNavState
      );
    }
  },
  mounted() {
    window.scroll(0, 0);
    document.title = `${this.info.custom_name || this.info.name}`;
    this.load();

    this.$nextTick(() => {
      const scrollContainer = this.$refs["scroll-cat"];
      if (scrollContainer) {
        this.categoryScrollContainer = scrollContainer;
        scrollContainer.addEventListener("wheel", this.handleCategoryWheel, {
          passive: false,
        });
        scrollContainer.addEventListener("scroll", this.updateCategoryNavState, {
          passive: true,
        });
      }
      window.addEventListener("scroll", this.scroll, { passive: true });
      window.addEventListener("resize", this.updateCategoryNavState, {
        passive: true,
      });
      this.syncNavTheme();
      this.updateCategoryNavState();
    });

    // this.$nextTick(() => {
    //   const tour = this.$shepherd({
    //     useModalOverlay: true,
    //   });

    //   tour.addStep({
    //     attachTo: { element: '.', on: "top" },
    //     text: "Categorias",
    //     buttons: [
    //       {
    //         text: "Next",
    //         action: tour.next,
    //       },
    //     ],
    //   });

    //   tour.start();
    // });
  },
  methods: {
    normalizeCategoryColor(value) {
      if (typeof value !== "string") return null;
      const color = value.trim();
      if (/^#[0-9a-f]{6}$/i.test(color)) return color;
      if (/^#[0-9a-f]{3}$/i.test(color)) {
        return `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`;
      }
      return null;
    },
    syncNavTheme() {
      this.$nextTick(() => {
        const nav = this.$refs["nav-categories"];
        if (!nav || !window.getComputedStyle) return;

        const styles = window.getComputedStyle(nav);
        const backgroundColor = styles.backgroundColor || "rgb(255, 255, 255)";
        const match = backgroundColor.match(/\d+(\.\d+)?/g) || [];
        const [r = 255, g = 255, b = 255] = match.map(Number);
        const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
        const isDark = this.categoryMenuStyle === "chips"
          ? this.settings && this.settings.headerColor === "dark"
          : luminance < 0.55;
        const accent = this.categoryMenuAccent;
        const channels = [1, 3, 5].map((index) => parseInt(accent.slice(index, index + 2), 16));
        const [accentRed, accentGreen, accentBlue] = channels;
        const [redLight, greenLight, blueLight] = channels.map((channel) => {
          const value = channel / 255;
          return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
        });
        const accentLuminance = 0.2126 * redLight + 0.7152 * greenLight + 0.0722 * blueLight;
        const accentRgb = `${accentRed}, ${accentGreen}, ${accentBlue}`;

        this.navThemeVars = {
          "--category-accent": accent,
          "--category-accent-text": this.categoryMenuAccentText || (accentLuminance <= 0.183 ? "#fff" : "#172332"),
          "--category-accent-link-text": this.categoryMenuAccentText || accent,
          "--category-accent-soft": `rgba(${accentRgb}, 0.13)`,
          "--category-accent-hover": `rgba(${accentRgb}, 0.08)`,
          "--category-accent-border": `rgba(${accentRgb}, 0.45)`,
          "--category-accent-shadow": `rgba(${accentRgb}, 0.3)`,
          "--category-nav-bg": isDark ? "rgba(15, 23, 42, 0.82)" : "rgba(255, 255, 255, 0.92)",
          "--category-nav-color": isDark ? "rgba(255, 255, 255, 0.92)" : "#475569",
          "--category-nav-shadow": isDark
            ? "0 10px 26px rgba(0, 0, 0, 0.28)"
            : "0 8px 24px rgba(15, 23, 42, 0.12)",
          "--category-nav-edge": isDark
            ? "rgba(15, 23, 42, 0.98)"
            : "rgba(255, 255, 255, 0.96)",
          "--category-scroll-thumb": isDark
            ? "rgba(148, 163, 184, 0.65)"
            : "rgba(148, 163, 184, 0.45)",
          "--category-chip-bg": isDark ? "#26343c" : "rgba(255, 255, 255, 0.96)",
          "--category-chip-color": isDark ? "#f5f7f8" : "#26333a",
          "--category-chip-hover": isDark ? "#33454e" : "#f8fafb",
        };
      });
    },
    categoryMenuIcon(category) {
      const configured = category.webIcon || category.menu_icon || category.icon;
      if (typeof configured === "string" && configured.trim()) return configured;

      const name = String(category.name || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
      if (/promo|oferta|descuento/.test(name)) return "tag-fill";
      if (/bebida|cafe|milkshake|jugo/.test(name)) return "cup-straw";
      if (/burger|sandwich|panini/.test(name)) return "egg-fried";
      if (/sushi|roll|handroll/.test(name)) return "circle";
      if (/ceviche|gohan|bowl/.test(name)) return "basket";
      if (/cobertura|extra/.test(name)) return "layers";
      if (/variedad/.test(name)) return "grid-3x3-gap";
      return "bag";
    },
    getPromos(product) {
      const promos = product.promos;
      const value = product.value;

      if (!promos) return false;

      const enabled = promos.filter((p) => p.enabled);

      let rs = "";

      //console.log({ promos, enabled });

      if (enabled) {
        enabled.forEach((promo) => {
          rs += this.getPromo(promo, value, true);
        });
      }

      return rs;
    },
    getExclusiveAvailability(product = {}) {
      const values = Array.isArray(product.available_on)
        ? product.available_on
        : [];

      if (values.length !== 1) return "";

      const [value] = values;
      if (value == "pickup") return "Solo retiro";
      if (value == "delivery") return "Solo domicilio";
      if (value == "shipping") return "Solo envio";
      return "";
    },
    isPromoActiveForQty(promo = {}, qty = 1) {
      if (!promo || !promo.enabled) return false;
      if (promo.when == "qty") return this.checkCondition(qty, promo.is, promo.value);
      if (!promo.when) return true;
      return promo.when != "total" && promo.when != "minopcion";
    },
    getCardPrice(product = {}) {
      const promos = Array.isArray(product.promos) ? product.promos : [];
      const baseValue = Number(product.value) || 0;
      const promo = promos.find((item) => item && item.enabled);
      if (!promo) return baseValue;
      if (!this.isPromoActiveForQty(promo, 1)) return baseValue;

      if (promo.to == "product") {
        if (promo.in == "%") {
          return Math.max(
            baseValue - baseValue * ((Number(promo.discount) || 0) / 100),
            0
          );
        }

        return Math.max(baseValue - (Number(promo.discount) || 0), 0);
      }

      if (promo.to == "total" && promo.when == "qty" && Number(promo.value) <= 1) {
        if (promo.in == "%") {
          return Math.max(baseValue - baseValue * ((Number(promo.discount) || 0) / 100), 0);
        }
        if (promo.in == "$") {
          return Math.max(baseValue - (Number(promo.discount) || 0), 0);
        }
      }

      return baseValue;
    },
    /* eslint-disable no-unused-vars */
    showProductImage(image = null) {
      if (this.settings.productImage == "hide") return false;
      if (this.settings.productImage == "isvalid" && image == "") return false;
      return true;
    },
    updateProductData(data) {
      console.log("update product data");
      this.productName = data;
    },
    updateCategoryNavState() {
      this.$nextTick(() => {
        const container = this.$refs["scroll-cat"];
        if (!container) return;

        const maxScrollLeft = Math.max(
          container.scrollWidth - container.clientWidth,
          0
        );
        const hasOverflow = maxScrollLeft > 8;

        this.hasCategoryOverflow = hasOverflow;
        this.showLeftCategoryNav = hasOverflow && container.scrollLeft > 8;
        this.showRightCategoryNav =
          hasOverflow && container.scrollLeft < maxScrollLeft - 8;
      });
    },
    scrollCategories(direction = "right") {
      const container = this.$refs["scroll-cat"];
      if (!container || !container.scrollBy) return;

      const amount = Math.max(container.clientWidth * 0.6, 180);
      container.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
      setTimeout(() => this.updateCategoryNavState(), 250);
    },
    handleCategoryWheel(evt) {
      const container = this.categoryScrollContainer;
      if (!container || Math.abs(evt.deltaY) <= Math.abs(evt.deltaX)) return;
      evt.preventDefault();
      container.scrollLeft += evt.deltaY;
    },
    scroll(e) {
      if (Date.now() - this.lastscroll > 2500) {
        console.log(e);
        let currentid;
        let index;
        let sections = document.getElementsByClassName("section");
        let scrollTop = window.pageYOffset + 100;

        for (let i = 0; i < sections.length; i++) {
          let sHeight = sections[i].offsetHeight;
          let offSet = sections[i].offsetTop;
          let { id } = sections[i].dataset;
          //const [el] = this.$refs[`cat-${id}`];

          if (scrollTop > offSet && scrollTop < offSet + sHeight) {
            console.log("section active", id);
            currentid = id;
            index = i;
          }
        }
        // console.log(sections)
        if (currentid) {
          this.cid = currentid;
          console.log(index);
          //  let items = document.querySelectorAll("a.item");
          // items[index].scrollIntoView({
          //   inline: "center",
          //   behavior: "smooth",
          // });
          // this.$router.push({ hash: currentid });
        }
        this.$store.commit("setLastscroll", Date.now());
      }
    },
    closeModal() {
      this.$refs.modal.hide();
      // window.scrollTo(0, 0);
    },
    listProducts(cat) {
      let cid = cat._id;
      return this.products.filter((p) => {
        const belongsToCategory = (p.category && p.category._id == cid) || p.category == cid;
        if (!belongsToCategory) return false;
        if (!this.showSearch || !this.searchQuery) return true;
        const query = this.searchQuery.toLocaleLowerCase();
        return `${p.name || ''} ${p.description || ''} ${cat.name || ''}`.toLocaleLowerCase().includes(query);
      });
    },
    getCategory(p) {
      if (p.category && p.category.name) return p.category.name;
      return "Sin Categoria";
    },
    load() {
      const id = this.$store.state.info.webName;
      console.log("id", id);
      if (!id || id == undefined) return false;
      this.$http.get(id + "/category").then((res) => {
        //this.categories = res.data.data;
        this.$store.commit("setCategories", res.data.data);
      });
      let query = "";
      if (this.category && this.category._id) {
        query = `category=${this.category._id}`;
      }
      this.$http.get(`${id}/product?${query}`).then((res) => {
        this.products = res.data.data;
        this.loading = false;
      });

      if (this.settings.showMostSoldProducts)
        this.$http.get(`${id}/product/mostselled`).then((res) => {
          this.listProductsMostSelled = res.data.data;
        });

      if (this.settings.showRecomended)
        this.$http.get(`${id}/product/recomended`).then((res) => {
          this.recomendedList = res.data.data;
        });

      let page = this.info.pages.find((p) => {
        if (p.slug == "menu") return p;
      });
      if (!page) {
        if (this.info.pages && this.info.pages.length >= 1) {
          let [firstPage] = this.info.pages;
          this.$router.push(this.getLink(firstPage.slug));
        }
        // this.$router.push(`/${this.info.webName}`);
        return false;
      }

      this.$http
        .get(`${id}/page/${page.slug}`)
        .then((res) => {
          this.page = res.data.data;
          document.title = `${this.page.title} - ${
            this.info.custom_name || this.info.name
          }`;
        })
        .catch(() => {
          //this.$router.push(this.getLink("404"));
          console.error("Error al cargar la pagina");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setCategory(cat, evt) {
      this.cid = cat._id;
      this.$store.commit("setLastscroll", Date.now());
      this.$gtag.event("category_click", {
        event_category: "product",
        event_label: "User click category",
        value: cat._id,
      });

      setTimeout(() => {
        const [el] = this.$refs[`fat-${cat._id}`];
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
      const categoryLink = evt && evt.currentTarget;
      if (categoryLink && categoryLink.scrollIntoView) {
        categoryLink.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }

      // clear spaces from category name and lowercase
      // let catName = cat.name.replace(/\s/g, "-").toLowerCase();

      //this.$router.push({ hash: catName });

      // this.load();
    },
    viewProduct(pid, pname = "") {
      //const { info } = this.$store.state;
      //this.$router.push(`/${info.webName}/p/${pid}`);
      // this.pid = pid;
      //if (pname) this.productName = pname;
      //this.$refs.modal.show();
      this.$router.push({
        query: {
          pid: pid,
          producto: pname,
        },
      });
      this.$gtag.event("product_view", {
        event_category: "product",
        event_label: "User view product",
        value: 1,
      });
      if (this.settings.facebookPixelEnabled && this.$analytics) {
        console.log("track view content");
        this.safeFbq("track", "ViewContent", {
          pid: this.pid,
          content_name: pname,
        });
      }
    },
  },
  watch: {
    loading() {
      if (!this.loading) {
        const scrolLCat = () => {
          const cid = this.$route.query.c;
          if (cid) {
            const [el] = this.$refs[`fat-${cid}`];
            el.scrollIntoView({ behavior: "smooth" });
          }
        };

        setTimeout(() => {
          scrolLCat();
        }, 1000);
      }
    },
    info() {
      this.load();
      this.syncNavTheme();
      this.updateCategoryNavState();
    },
    settings: {
      deep: true,
      handler() {
        this.syncNavTheme();
        this.updateCategoryNavState();
      },
    },
    categories() {
      this.updateCategoryNavState();
    },
  },
};
</script>

<style scoped>
.menu-search {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 0;
  padding: 11px 15px;
  border: 1px solid #dce4ec;
  border-radius: 14px;
  background: #fff;
  color: #66788b;
  box-shadow: 0 8px 24px rgba(24, 43, 64, 0.05);
}
.menu-search:focus-within { border-color: #2581ca; box-shadow: 0 0 0 3px rgba(37, 129, 202, 0.11); }
.menu-search input { width: 100%; border: 0; outline: 0; background: transparent; color: #20344a; }
.menu-search-empty { display: grid; justify-items: center; padding: 48px 20px; color: #607286; text-align: center; }
.menu-search-empty > svg { margin-bottom: 10px; font-size: 1.6rem; }
.menu-search-empty strong { color: #20344a; }
.menu-search-empty p { margin: 6px 0 16px; }
.menu-search-empty button { padding: 8px 16px; border: 1px solid #dce4ec; border-radius: 8px; background: #fff; color: #257ac0; }
.home-category-section {
  margin-top: clamp(1.5rem, 3vw, 2.25rem);
  scroll-margin-top: 80px;
}
.home-category-header {
  text-align: center;
  margin-bottom: 0.5rem;
}
.home-category-header--left {
  text-align: left;
}
.home-category-header--right {
  text-align: right;
}
.home-category-header__inner {
  display: inline-flex;
  align-items: flex-start;
  gap: 0.5em;
  max-width: 100%;
}
.home-category-header__copy {
  min-width: 0;
}
.home-category-heading {
  margin-bottom: 0;
}
.home-category-heading__icon {
  flex: 0 0 auto;
  color: var(--category-accent, #e6222e);
  font-size: clamp(1.4rem, 2.4vw, 1.9rem);
  width: clamp(1.4rem, 2.4vw, 1.9rem);
  height: clamp(1.4rem, 2.4vw, 1.9rem);
  margin-top: 0.08rem;
}
.home-category-description {
  max-width: 68ch;
  margin: 0.45rem 0 0;
  color: var(--ticketapp-page-text-color, #64748b);
  opacity: 0.78;
  line-height: 1.5;
  white-space: pre-line;
}
.home-product-grid {
  margin-left: -4px;
  margin-right: -4px;
}
.home-product-grid__item {
  padding-left: 4px;
  padding-right: 4px;
}
@media (max-width: 767px) {
  .home-category-section {
    margin-top: 1.5rem;
    scroll-margin-top: 72px;
  }
}
.product-single .product-single__title {
  color: var(--product-single-title-color, #212529);
}
.home-product-card {
  height: 100%;
  overflow: hidden;
  border: 1px solid #e6e9e3;
  border-radius: 14px;
  background: #fff;
}
.home-product-card > .row {
  flex: 1;
  width: 100%;
  margin: 0;
}
.home-product-card__media {
  background: #f4f5f1;
}
.home-product-card__image {
  display: block;
  width: 100%;
  object-fit: cover;
}
.home-product-card__details {
  display: flex;
  align-items: center;
  min-width: 0;
}
.home-product-card__details .card-body {
  min-width: 0;
}
.home-product-card--horizontal .home-product-card__media {
  flex: 0 0 34%;
  max-width: 34%;
  height: 160px;
  min-height: 150px;
}
.home-product-card--horizontal .home-product-card__image {
  height: 160px;
}
.home-product-card--horizontal .home-product-card__details {
  flex: 1 1 66%;
  max-width: 66%;
}
.home-product-card--vertical > .row {
  flex-direction: column;
}
.home-product-card--vertical .home-product-card__media {
  flex: 0 0 auto;
  width: 100%;
  max-width: 100%;
  min-height: 0;
  aspect-ratio: 16 / 10;
}
.home-product-card--vertical .home-product-card__image {
  height: auto;
  aspect-ratio: 16 / 10;
}
.home-product-card--vertical .home-product-card__details {
  flex: 1 0 auto;
  width: 100%;
  max-width: 100%;
  padding: 14px !important;
}
.home-product-card--vertical .home-product-card__details .card-body {
  width: 100%;
}
.home-product-card--vertical .product-single__title {
  display: block;
  margin-bottom: 5px;
}
.home-product-card--vertical .badge-danger {
  margin-bottom: 5px;
}
.home-product-card--vertical .home-product-card__details small:last-child {
  line-height: 1.4;
}
.home-product-card:focus-within,
[role="button"]:focus-visible .home-product-card {
  outline: 3px solid #7da38a;
  outline-offset: 2px;
}
.card-product {
  transition: all 0.5s;
  box-shadow: 0 0.4rem 1rem rgb(0 0 0 / 15%) !important;
}
.card-product:hover {
  box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 35%) !important;
}
.home-availability-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.28rem 0.55rem;
  border-radius: 999px;
  background: #eff6ff;
  border: 1px solid rgba(59, 130, 246, 0.18);
  color: #1d4ed8;
  line-height: 1;
}
.home-availability-label {
  font-size: 10px;
  text-transform: uppercase;
  opacity: 0.72;
  margin: 0;
}
.home-availability-value {
  font-size: 12px;
  font-weight: 700;
}
#scroll-categories::-webkit-scrollbar {
  display: none;
}
.category-nav__scroller {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  max-width: 100%;
  height: 60px;
  padding: 0 12px;
  overflow-y: hidden;
  overflow-x: scroll;
  scroll-snap-type: x proximity;
  scroll-padding-inline: 12px;
  scroll-behavior: smooth;
  overscroll-behavior-x: contain;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.category-nav {
  position: absolute;
  top: 50%;
  z-index: 2;
  transform: translateY(-50%);
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--category-nav-bg, rgba(255, 255, 255, 0.92));
  color: var(--category-nav-color, #475569);
  box-shadow: var(--category-nav-shadow, 0 8px 24px rgba(15, 23, 42, 0.12));
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.category-nav:hover {
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.2);
  transform: translateY(-50%) scale(1.05);
}
.category-nav:focus-visible {
  outline: 3px solid var(--category-accent, #e6222e);
  outline-offset: 2px;
}
.category-nav--left {
  left: 8px;
}
.category-nav--right {
  right: 8px;
}
#nav-categories.nav-categories--can-scroll-left::before,
#nav-categories.nav-categories--can-scroll-right::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 54px;
  z-index: 1;
  pointer-events: none;
}
#nav-categories.nav-categories--can-scroll-left::before {
  left: 0;
  background: linear-gradient(90deg, var(--category-nav-edge, rgba(255, 255, 255, 0.96)) 0%, rgba(255, 255, 255, 0) 100%);
}
#nav-categories.nav-categories--can-scroll-right::after {
  right: 0;
  background: linear-gradient(270deg, var(--category-nav-edge, rgba(255, 255, 255, 0.96)) 0%, rgba(255, 255, 255, 0) 100%);
}
.item {
  width: auto;
  min-width: auto;
  text-align: center;
  padding: 0 0px;
  scroll-snap-align: center;
  font-weight: 600;
}
.category-nav__item {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  height: 100%;
  padding: 0 0.2rem !important;
  border: 0 !important;
}
.category-nav__link {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  padding: 0.55rem 0.85rem;
  border-radius: 999px;
  color: var(--category-nav-color, #475569);
  font-size: 0.79rem;
  font-weight: 700;
  letter-spacing: 0.035em;
  line-height: 1.15;
  text-decoration: none !important;
  scroll-snap-align: center;
  transition: background-color 0.16s ease, color 0.16s ease, transform 0.16s ease;
}
.category-nav__link:hover {
  background: var(--category-accent-hover, rgba(230, 34, 46, 0.08));
  color: var(--category-accent, #e6222e);
}
.category-nav__link.active {
  background: var(--category-accent-soft, rgba(230, 34, 46, 0.13));
  color: var(--category-accent-link-text, #e6222e);
  font-weight: 800;
}
.category-nav__link:focus-visible {
  outline: 2px solid var(--category-accent, #e6222e);
  outline-offset: 2px;
}
#nav-categories.nav-categories--chips {
  border-bottom: 0 !important;
  border-radius: 16px;
  background: var(--category-nav-bg, rgba(255, 255, 255, 0.92));
  box-shadow: 0 6px 22px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(12px);
}
.nav-categories--chips .category-nav__scroller {
  height: 60px;
  gap: 0.15rem;
}
.nav-categories--chips .category-nav__link {
  min-height: 36px;
  gap: 0.5rem;
  padding: 0.5rem 0.85rem;
  border: 1px solid rgba(115, 129, 137, 0.08);
  background: var(--category-chip-bg, #fff);
  color: var(--category-chip-color, #26333a);
  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.08);
  font-size: 0.77rem;
  font-weight: 650;
  letter-spacing: 0;
  text-transform: none !important;
}
.nav-categories--chips .category-nav__link:hover {
  background: var(--category-chip-hover, #f8fafb);
  color: var(--category-chip-color, #26333a);
  transform: translateY(-1px);
}
#nav-categories.nav-categories--chips .category-nav__link.active,
#nav-categories.nav-categories--chips .category-nav__link.active:hover {
  border-color: transparent;
  background: var(--category-accent, #e6222e);
  color: var(--category-accent-text, #fff) !important;
  box-shadow: 0 5px 14px var(--category-accent-shadow, rgba(230, 34, 46, 0.3));
}
.nav-categories--chips .category-nav__icon {
  width: 1rem;
  height: 1rem;
  flex: 0 0 1rem;
}
.nav-categories--underline .category-nav__link {
  border-radius: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  box-shadow: none;
}
.nav-categories--underline .category-nav__link:hover {
  background: transparent;
  color: var(--category-nav-color, #475569);
  border-bottom-color: var(--category-accent-border, rgba(230, 34, 46, 0.45));
}
.nav-categories--underline .category-nav__link.active {
  background: transparent;
  color: var(--category-accent-link-text, #e6222e);
  border-bottom-color: var(--category-accent, #e6222e);
}
#nav-categories {
  position: sticky;
  top: 0;
  overflow-x: auto;
  z-index: 20;
  padding-inline: 0;
}
.nav-categories1 {
  background: rgb(20 20 20 / 90%);
  color: white;
}
@media (max-width: 767px) {
  .category-nav__scroller {
    height: 56px;
    gap: 0.1rem;
    padding: 0 10px;
    scroll-padding-inline: 10px;
  }
  .category-nav__link {
    min-height: 36px;
    padding: 0.5rem 0.68rem;
    font-size: 0.74rem;
  }
  .category-nav {
    width: 30px;
    height: 30px;
  }
  .nav-categories--chips .category-nav__scroller {
    height: 54px;
  }
  .nav-categories--chips .category-nav__link {
    min-height: 36px;
    font-size: 0.73rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .category-nav,
  .category-nav__link {
    transition: none;
  }
}
</style>
